import { render } from "./ChatSendButton.vue?vue&type=template&id=4c0f4562"
import script from "./ChatSendButton.vue?vue&type=script&lang=js"
export * from "./ChatSendButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__